import styled from 'styled-components';

export const ViewContainer = styled.div`
  overflow-x: hidden;
  display: flex;
  flex: 1;
  flex-direction: column;
  width: calc(100vw - 105px);

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    width: 100vw;
    margin: 0;
    padding: 0;
  }

  .travelMapContainer {
    width: 100%;
    height: 90vh;
    position: relative;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      height: calc(80vh - 70px);
    }
  }

  .travelContentContainer {
    margin: -2vh 0 20px 20px;
    width: calc(100% - 20px);

    > :not(:last-child) {
      margin-bottom: 20px;
    }

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin: -5vh 16px 16px 16px;
      width: calc(100vw - 32px);
    }
  }

  .travelContentContainer > * {
    @media (min-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      margin-right: 20px;
    }
  }

  .travelPosTitleCard {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    > div {
      margin: 15px 0 0 0;
      text-transform: initial;
    }
  }

  .downloadMarketPresentation {
    position: absolute;
    border: none;
    border-radius: 50px;
    top: 20px;
    right: 30px;
    z-index: 3;
    text-align: center;
    font-size: 11px;
    text-transform: none;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      bottom: 8vh;
      display: flex;
      width: 100%;
      justify-content: center;
      top: unset;
      right: 0;
      left: 0;
    }
  }
`;
